module.exports = __webpack_public_path__ + "img/Sanitätszug.6988eb93.svg";